import React from 'react';
import { Outlet } from 'react-router-dom';

export function ListAchievementPgd() {
  return (
    <React.Fragment>
      <Outlet />
    </React.Fragment>
  );
}
